export default __webpack_public_path__ + "img/exclamation-circle-error.ab21d065.svg";